import React from "react";
import styled from "@emotion/styled";
import ReactPlayer from "react-player";
import "../App.css";

const Demo = ({ video, text, title, isVisible }) => {
  const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 5vh;

    @media (max-width: 1100px) {
      min-width: 0;
      flex-direction: column;
    }
  `;
  const Vid = styled.div`
    outline: none;
    width: 45vw;
    z-index: 1;
    -webkit-box-shadow: 0 10px 6px -6px #777;
    -moz-box-shadow: 0 10px 6px -6px #777;
    box-shadow: 0 10px 6px -6px #777;
    outline: none;

    @media (max-width: 1100px) {
      width: 100%;
      margin-bottom: 10px;
    }
  `;

  const Title = styled.div`
    font-weight: 450;
    font-size: 2.5em;
    margin-bottom: 1vh;
    color: #35a1f9;
  `;
  const Text = styled.div`
    font-size: 1.5vw;
    line-height: 1.4em;

    @media (max-width: 1100px) {
      font-size: 1.5em;
    }
  `;

  const TextSide = styled.div`
    width: 30vw;

    @media (max-width: 1100px) {
      width: 100%;
      min-width: 0;
    }
  `;

  const PlayButton = styled.button`
    background: #fc6161;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    width: 8vw;
    height: 4vh;
    margin-top: 1.5vh;
    color: #ffffff;
  `;

  const RestartButton = styled.button`
    margin-left: 2vw;
    background: #fc6161;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    width: 8vw;
    height: 4vh;
    margin-top: 1.5vh;
    color: #ffffff;
  `;

  const videoStyle = {
    outline: "none !important",
  };

  return (
    <div>
      <Container>
        <Vid>
          <ReactPlayer
            width={"100%"}
            height={"100%"}
            url={video}
            controls={true}
            muted={true}
            style={videoStyle}
            className="reactPlayer"
          ></ReactPlayer>
        </Vid>
        <TextSide
          className={
            isVisible ? "animated fadeInRight faster" : "animated fadeOutRight"
          }
        >
          <Title>{title}</Title>
          <Text>{text}</Text>
          {/* <PlayButton>Play</PlayButton>
          <RestartButton>Replay</RestartButton> */}
        </TextSide>
      </Container>
    </div>
  );
};

export default Demo;
